import palette from '@assets/theme/palette';
import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const RequiredDocumnetsModuleStyledContainer = styled(Box)`
  .card {
    display: flex;
    position: relative;
    gap: 20px;
    flex-direction: column;
  }

  .module-title {
    color: #3460b4;
    font-weight: 500;
    font-size: 16px;
  }

  .document-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
  }

  .upload-file-btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed rgba(65, 91, 117, 0.32);
    border-radius: 8px;
    height: 100%;
    width: 100%;
    min-height: 56px;
    background-color: transparent;
    cursor: pointer;

    &.error {
      border-color: ${palette.dark.error.main};

      .upload-file-btn__label {
        color: ${palette.dark.error.main};
      }
    }

    svg {
      font-size: 24px;
      color: ${palette.light.green[300]};
    }

    &__wrapper {
      z-index: 100;
      height: 22px;
      background-color: red;
      width: 100%;
    }

    &__label {
      position: absolute;
      top: -11px;
      left: 17px;
      font-size: 12px;
      line-height: 22px;
      font-weight: 600;
      color: #707070;
      background-color: #ffffff;
      padding: 0 2px;
      border-radius: 5px;
    }
  }

  .document-file {
    .MuiOutlinedInput-notchedOutline {
      border-color: #dbe0ec;
    }

    .MuiOutlinedInput-input {
      color: #383838;
      -webkit-text-fill-color: #383838;
    }

    .MuiInputLabel-outlined {
      color: #707070;
    }
  }
`;

export { RequiredDocumnetsModuleStyledContainer };
